import React from 'react';
import PropTypes from 'prop-types';

import Box from './layout/Box';

const ListItem = ({ before, after, children, className, style, ...other }) => {
  return (
    <Box
      className={`flex-row flex-grow-1 flex-shrink-1 ${className}`}
      style={style}
      {...other}
    >
      {before && <Box className="flex-shrink-0">{before}</Box>}
      <Box className="flex-row align-items-center flex-grow-1 flex-shrink-1">
        {children}
      </Box>
      {after && <Box className="align-items-center flex-shrink-0">{after}</Box>}
    </Box>
  );
};

ListItem.defaultProps = {
  before: undefined,
  after: undefined,
  style: {},
  className: '',
};

ListItem.propTypes = {
  before: PropTypes.node,
  after: PropTypes.node,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default ListItem;
